import styled from 'styled-components';
import { PreviewWrapper, StyledReactMarkdown } from 'Common/Components/v2/MarkdownEditor/MarkdownInput/components/MDPreview/styled';

export const Wrapper = styled(PreviewWrapper)`
  background-color: transparent;
  max-height: 38px;
  padding: 0;
  overflow: hidden;
`;
Wrapper.displayName = 'Wrapper';

export const StyledMd = styled(StyledReactMarkdown)`
  color: ${({ theme }) => theme.text.tableItem};
  font-size: 12.5px;
`;
StyledMd.displayName = 'StyledMd';
